module.exports = __webpack_public_path__ + "static/img/lottery_icons.2eba23a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/lottery_icons.png
// module id = mcd0
// module chunks = 212